/**
 * <a is="load-more-button"> — charge la page suivante en AJAX et ajoute les produits
 * à la grille (<product-list>) sans recharger la page. Met à jour la barre de progression
 * et l'URL du bouton à partir de la page récupérée. Repli : navigation classique si erreur.
 */
if (!customElements.get('load-more-button')) {
  class LoadMoreButton extends HTMLAnchorElement {
    constructor() {
      super();
      this.addEventListener('click', this.onClick.bind(this));
    }

    async onClick(event) {
      event.preventDefault();
      if (this.dataset.loading) return;
      this.dataset.loading = '1';
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(this.href);
        if (!response.ok) throw new Error('Network error');

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('product-list');
        const destination = document.querySelector('product-list');

        if (source && destination) {
          destination.insertAdjacentHTML('beforeend', source.innerHTML);
        }

        const newZone = doc.querySelector('load-more-zone');
        const currentZone = this.closest('load-more-zone');
        if (currentZone) {
          if (newZone) {
            currentZone.outerHTML = newZone.outerHTML;
          } else {
            currentZone.remove();
          }
        }
      } catch (error) {
        // Repli : on suit le lien normalement
        window.location.href = this.href;
      }
    }
  }

  customElements.define('load-more-button', LoadMoreButton, { extends: 'a' });
}
